import { Component } from '@angular/core';
import { CanViewMappingsComponent } from './can-view-mappings.component';
import { CanValidateMappingsComponent } from './can-validate-mappings.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'eaa-mappings-nav-menu',
  imports: [CanValidateMappingsComponent, CanViewMappingsComponent, RouterLink],
  template: `
    <eaa-can-view-mappings>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="bi bi-bounding-box-circles" aria-hidden="true"></span> MAPPINGS
        </a>
        <ul class="dropdown-menu">
          <eaa-can-validate-mappings>
            <li>
              <a class="dropdown-item" [routerLink]="['/mappings', 'pending-check']">VALIDATE MAPPINGS</a>
            </li>
          </eaa-can-validate-mappings>
        </ul>
      </li>
    </eaa-can-view-mappings>
  `
})
export class MappingsNavMenuComponent {}
